import React, { useEffect } from 'react';
import PublicHeader from './PublicHeader';
import './AboutPage.css';

const TILES = [
  {
    title: 'Create custom client and window types',
    description: 'Set up customer types and window pricing your way.',
    image: '/quotepreview.png',
  },
  {
    title: 'Fast on-site bidding',
    description: 'No math, calculator, or app switching. Quote in one place.',
    image: '/quotecreate.png',
  },
  {
    title: 'Clean quote storage',
    description: 'All your quotes in one place. Search, view, and manage with ease.',
    image: '/quoteview.png',
  },
];

const AboutPage = () => {
  useEffect(() => {
    document.title = 'Squeekit - About';
  }, []);

  return (
    <div className="about-page">
      <PublicHeader />
      <main className="about-page__main">
        <div className="about-page__title" aria-hidden="true" />
        <div className="about-page__tiles">
          {TILES.map((tile, index) => (
            <div key={index} className="about-page__tile">
              <div className="about-page__tile-text">
                <h2 className="about-page__tile-title">{tile.title}</h2>
                <p className="about-page__tile-desc">{tile.description}</p>
              </div>
              <div className="about-page__tile-image-wrap">
                <img
                  src={tile.image}
                  alt=""
                  className="about-page__tile-image"
                />
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default AboutPage;
